/**
 * 把一段文字写进剪贴板，返回是否成功。从不抛错。
 *
 * 管端可能被 super-admin 用 wujie 或 iframe 承载：iframe 没给 `clipboard-write` 权限时
 * `navigator.clipboard.writeText` 会以 NotAllowedError 拒绝，非安全上下文里干脆没有 `navigator.clipboard`。
 * 所以按顺序退：异步剪贴板 → 隐藏 textarea + `execCommand("copy")`。两条都不行返回 false，
 * 调用方把文字摆出来让人手动复制。
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch { /* 落到下面的兜底 */ }
  try {
    const area = document.createElement("textarea");
    area.value = text;
    area.setAttribute("readonly", "");
    area.style.position = "fixed";
    area.style.top = "0";
    area.style.left = "0";
    area.style.opacity = "0";
    document.body.appendChild(area);
    area.select();
    area.setSelectionRange(0, text.length);
    const ok = document.execCommand("copy");
    area.remove();
    return ok;
  } catch {
    return false;
  }
}
